import { Dialog, Stack, Text, Portal } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { removeDocumentStructure } from '../../lib/state/slices/ProjectStateSlice';
import StyledButton from '../ui/styledButton';

export default function DeleteGraphDialog(props: {
  isOpen: boolean;
  onClose: () => void;
  graphId: string;
}) {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Dialog.Root open={props.isOpen} onOpenChange={props.onClose}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content backgroundColor="midCardBG">
            <Dialog.Header>
              <Dialog.Title color="primaryText">Delete Graph</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body>
              <Stack gap={4}>
                <Text color="secondaryText">Are you sure you want to delete this graph?</Text>
              </Stack>
            </Dialog.Body>
            <Dialog.Footer>
              <StyledButton variant="outline" text="Cancel" onClick={props.onClose} />
              <StyledButton
                variant="danger"
                text="Delete"
                onClick={() => {
                  if (location.pathname === `/graphs/${props.graphId}`) {
                    navigate('/graphs');
                  }
                  dispatch(
                    removeDocumentStructure({
                      key: props.graphId,
                      type: 'GRAPH',
                    }),
                  );

                  props.onClose();
                }}
                />
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}
